<template>
  <div class="container">
    <div class="col-md-12"><h2>{{ labels.title }}</h2></div>
    <div class="row mt-5">
        <div class="col-md-2"></div>
        <div class="col-md-4 h5">
            <label for="selVigencia" class=""> {{ labels.vigencia }}</label>
            <select id="selVigencia" name="" v-model="selVigencia">
                <option value="">Seleccione...</option>
                <option v-for="vigencia in listVigencia" :key="vigencia.vigencia"> {{ vigencia.vigencia }}</option>
            </select>
        </div>
        <div class="col-md-5 h5">
            <label for="company" class=""> {{ labels.company }}</label>
            <select id="company" name="" v-model="companyId">
                <option value="">Seleccione...</option>
                <option v-for="company in listCompany" :value="company.id" :key="company.id">{{ company.acronym+" "+company.nombre }}</option>
            </select>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-md-12">
            <b-button @click="consulReporteECP()" id="consult-btn">{{ labels.consultar }}</b-button>
        </div>
    </div>
    <div class="row col-md-12 mt-4" v-if="showRowCol">
        <div class="col-md-1"></div>
        <div class="col-md-5">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="newFila">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="col-md-5">
            <md-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="newColumna">
                <md-icon>add</md-icon>
            </md-button>
        </div>
        <div class="col-md-1"></div>
    </div>
    <div class="row mt-3" v-if="showRowCol">
        <div class="col-md-1"></div>
        <div class="col-md-5">
            <!-- <EcpFila/> -->
            <div class="headNivUno">
                {{ labels.fila }}
            </div>
            <div class="bodyFila" v-if="listFila.length == 0">
                <!-- <input type="text" id="inpFila" v-model="fila" class="form-control" placeholder="Fila..."> -->
                {{ labels.notRow }}
            </div>
            <div v-else>
                <div class="bodyFila" v-for="fila in listFila" :key="fila.id">
                    {{ fila.fila }} . {{ fila.descripcion }}
                </div>
                <!-- <input type="text" id="inpFila" v-model="fila" class="form-control" placeholder="Fila..."> -->
            </div>
        </div>
        <div class="col-md-5">
            <!-- <EcpColumnaVue/> -->
            <div class="headNivUno">{{ labels.columna }}</div>
            <div class="bodyColumna" v-if="listColumna.length == 0">
                <!-- <input type="text" id="inpColumna" v-model="columna" class="form-control" placeholder="Columna..."> -->
                {{ labels.notRow }}
            </div>
            <div v-else>
                <div class="bodyColumna" v-for="columna in listColumna" :key="columna.id">
                    {{ columna.columna }} . {{ columna.descripcion }}
                </div>
            </div>
        </div>
        <div class="col-md-1"></div>
    </div>
    <div class="row mt-5" v-if="showRowCol">
        <div class="col-md-12">
            <b-button @click="consultECP()" id="consult-btn">{{ labels.detail }}</b-button>
        </div>
    </div>
    <NewFilaVue :showFila="showModFila" @closeModal="cierraModal" @reloadTblFila="recargaTblFila"/>
    <NewColumna :showColumna="showModColumna" @closeModal="cierraModal" @reloadTblColumna="recargaTblColumna"/>
    <EcpFilaColumna v-if="showListFilaCol" :vigCompSel="infoVigeCom" :consulDetallEcp="infoVigeCom"/>
  </div>
</template>
<script>

import PlanCuentas from '../../services/PlanCuentas'
import Company from '../../services/Company'
import EcpReporte from '../../services/EcpReporte'
// import EcpFila from './EcpFila.vue'
// import EcpColumnaVue from './EcpColumna.vue'
// import EcpBtnAgregarVue from './EcpBtnAgregar.vue'
import NewFilaVue from './NewFila.vue'
import NewColumna from './NewColumna.vue'
import EcpFilaColumna from './EcpFilaColumna.vue'

export default {
    name:'EcpReporte',
    components:{
        NewFilaVue,
        NewColumna,
        EcpFilaColumna
        // EcpFila,
        // EcpColumnaVue,
        // EcpBtnAgregarVue
    },
    data: () => ({
        selVigencia : "",
        companyId : "",
        listVigencia : [],
        listCompany : [],
        dataVigenCompa: {},
        showRowCol: false,
        fila : "",
        listFila : [],
        columna : "",
        listColumna : [],
        showModFila: false,
        showModColumna: false,
        showListFilaCol: false,
        infoVigeCom : {}
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Reporte ECP",
                    vigencia: "Vigencia:",
                    company: "Compañía:",
                    consultar: "Consultar",
                    fila: "FILA",
                    columna: "COLUMNA",
                    detail: "DETALLE",
                    notRow: "No hay Registros"
                }
            }else{
                return {
                    title: "ECP Report",
                    vigencia: "Validity:",
                    company: "Company:",
                    consultar: "Consult",
                    fila: "ROW",
                    columna: "COLUMN",
                    detail: "DETAIL",
                    notRow: "There are not records"
                }
            }
        }
    },
    methods:{
        consulReporteECP(){
            
            if(this.selVigencia != "" && this.companyId != ""){
                this.showRowCol = true

                this.dataVigenCompa = {
                    "vigencia" : this.selVigencia,
                    "compania" : this.companyId
                }
            
            }else{
                this.$toast.error("Diligenciar el campo vigencia y/o compañia")
            }
        },
        consultECP(){
            this.showListFilaCol = true
        },
        newFila(){
            // console.log("NewFila")
            this.showModFila = true
        },
        newColumna(){
            // console.log("NewColumna")
            this.showModColumna = true
        },
        cierraModal(val){

            this.showModFila = val
            this.showModColumna = val
        },
        recargaTblFila(val){

            this.showModFila = val

            EcpReporte.getAllFila()
            .then((res) => {
                this.listFila = res.data.allFila
            })
            .catch((err) => {
                console.log(err.message)
                this.listFila = []
            })
        },
        recargaTblColumna(val){

            this.showModColumna = val

            EcpReporte.getAllColumna()
            .then((res) => {
                this.listColumna = res.data.allColumn
            })
            .catch((err) => {
                console.log(err.message)
                this.listColumna = []
            })
        }
    },
    mounted(){

        PlanCuentas.getVigenciaPlancuentas()
        .then((result) => {
            // console.log(result.data.getVigencia)
            this.listVigencia = result.data.getVigencia
        })
        .catch((err) => {
            console.log(err)
        })

        Company.getAllCompanies()
        .then((result) => {
            // console.log(result)
            this.listCompany = result.data.companies
        })
        .catch((err) => {
            console.log(err)
        })

        EcpReporte.getAllFila()
        .then((res) => {
            this.listFila = res.data.allFila
        })
        .catch((err) => {
            console.log(err.message)
            this.listFila = []
        })

        EcpReporte.getAllColumna()
        .then((res) => {
            this.listColumna = res.data.allColumn
            // console.log(this.listColumna)
        })
        .catch((err) => {
            console.log(err.message)
            this.listColumna = []
        })

    },
    watch:{
        selVigencia(valNew){
            // console.log(valNew)
            this.infoVigeCom.vigencia = valNew
        },
        companyId(valNew){
            // console.log(valNew)
            this.infoVigeCom.companyId = valNew
        }
    }
}
</script>
<style src="../main.css"></style>
